import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import {
    getIsBitSet,
    ListViewBitFlagsMasks,
    setBit,
} from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { updateUserConfigurationAndService } from 'owa-session-store';
import densityOptionSelectedValue from 'owa-display-density-option/lib/utils/densityOptionSelectedValue';
import { isFeatureEnabled } from 'owa-feature-flags';

//Set density to be medium on the first ever load of monarch so we can highlight win32 features.
export function initializeNativeDensityForFirstRun() {
    const monarchDensityBitflag = ListViewBitFlagsMasks.isMonarchDensityInitialized;
    if (
        isFeatureEnabled('mon-densities') &&
        isHostAppFeatureEnabled('monarchDensity') &&
        !getIsBitSet(monarchDensityBitflag)
    ) {
        updateUserConfigurationAndService(
            config => {
                if (config.UserOptions) {
                    config.UserOptions.DisplayDensityMode = 'Simple';
                }
            },
            [
                {
                    key: 'DisplayDensityMode',
                    valuetype: 'Integer32',
                    value: [String(densityOptionSelectedValue('Simple'))],
                },
            ]
        );
        setBit(true /* value*/, monarchDensityBitflag);
    }
}
